import { ErrorMessage, Field, } from "formik";
import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import data from '../../../CommonUtilities/StaticData/DistMandal.json'
import villageData from '../../../CommonUtilities/StaticData/villages.json'
import states from '../../../CommonUtilities/StaticData/states.json'
import { handleInputToUppercase, handleKeyPressAlphabets, handleKeyPressNumeric } from "../../../CommonUtilities/Validations/RegularExpAndVar";
import Sweetalert from "../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import Swal from "sweetalert2";

export default function CommunicationDetails(props) {
    const { Formik, showdata, disableField } = props;
    const [showDistrictMandal, setDistrictMandal] = useState(data)
    const [showMandal, setMandal] = useState([])
    const [showVillage, setVillage] = useState([])
   // const [showMandalCode, setMandalCode] = useState(showdata?.mandal)
   //const [showDistCode, setDistCode] = useState(showdata?.district)
   const [showMandalCode, setMandalCode] = useState(showdata?.mandal || "");
   const [showDistCode, setDistCode] = useState(showdata?.district || "");
    useEffect(() => {
  if (showdata?.mandal) setMandalCode(showdata.mandal);
  if (showdata?.district) setDistCode(showdata.district);
}, [showdata?.mandal, showdata?.district]);
  //console.log("mm>>",showMandalCode);
    useEffect(() => {
        if (showDistCode && showDistrictMandal?.mandals?.length > 0) {
    const mandalList = showDistrictMandal.mandals.filter(
      (val) => val.dist_code === parseInt(showDistCode)
    );
    setMandal(mandalList);
  }

  if (
    showDistCode &&
    showMandalCode &&
    villageData?.villages?.length > 0
  ) {
    const villageList = villageData.villages.filter(
      (val) =>
        val.mandal_code === parseInt(showMandalCode) &&
        val.dist_code === parseInt(showDistCode)
    );
    setVillage(villageList);
  }
        // setMandal(showDistrictMandal?.mandals?.filter((val) => val.dist_code === parseInt(showDistCode)))

        // console.log("showDistricts",showDistrictMandal?.mandals?.filter((val) => val.dist_code === parseInt(showDistCode)))
        // setVillage(villageData?.villages?.filter((val) => val.mandal_code === parseInt(showMandalCode) && val.dist_code == parseInt(showDistCode)))
    }, [showMandalCode, showDistCode,showDistrictMandal])

    function onClearFieldValue(name) {

        Formik.setFieldValue(name, "")
    }

    return (

        <React.Fragment>
            <div className="personal-head mt-3">
                <span>Communication Details</span>
            </div>
            <div className="personal-row personal-row1 pb-3">
                <Row>
 <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
  <Form.Group controlId="isAndhra">
    <Form.Label className="input-lable mb-2">
      Do you belong to Andhra Pradesh state
      <font color="red">*</font>
    </Form.Label>
    <div className="form-border form-control">
      <Field
        type="radio"
        name="isAndhra"
        value="true"
        disabled={disableField}
        className="form-sub me-1"
        onChange={(e) => {
          Formik.handleChange(e); 
          Formik.setFieldValue("state", "");
          Formik.setFieldValue("district", "");
          Formik.setFieldValue("mandal", "");
          Formik.setFieldValue("village", "");
        }}/>
      Yes &nbsp;&nbsp;&nbsp;&nbsp;
      <Field
        type="radio"
        name="isAndhra"
        value="false"
        className="form-sub me-1"
        disabled={disableField}
       onChange={(e) => {
  Formik.handleChange(e);
  Formik.setFieldValue("state", "");
  Formik.setFieldValue("district", "");
  Formik.setFieldValue("mandal", "");
  Formik.setFieldValue("village", "");
  setDistCode("");
  setMandalCode("");
  setMandal([]);
  setVillage([]);
}}/>No  </div>
    <ErrorMessage
      name="isAndhra"
      component="div"
      className="text-error"
    />
  </Form.Group>
</Col>
                   {Formik?.values?.isAndhra === 'false' ?

                        <React.Fragment>
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <div className="input-div position-relative">
                                    <Form.Group controlId="state" >
                                        <Form.Label className="input-lable mb-3">State<font color="red">*</font></Form.Label>
                                        <Field as="select" className="input-field form-control" name='state'
                                            disabled={disableField}
                                            onChange={() => {
                                                onClearFieldValue('district')
                                                onClearFieldValue('mandal')
                                                onClearFieldValue('village')
                                            }}
                                        >
                                            <option>Select</option>
                                            {states?.states?.map((ds, i) => {
                                                return (<option key={i} value={ds.state_code}>{ds.state_name}</option>);
                                            })}

                                        </Field>
                                        <ErrorMessage
                                            name="state"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>
                                    <IoIosArrowDown className="dropdown-icon" />
                                </div>
                            </Col>
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <div className="input-div position-relative">
                                    <Form.Group controlId="district" >
                                        <Form.Label className="input-lable mb-3">District<font color="red">*</font></Form.Label>
                                        <Field type="text" name="district"
                                            maxLength='30'
                                            className="input-field form-control"
                                            onInput={(e) => { handleInputToUppercase(e) }}
                                            onKeyPress={(e) => { handleKeyPressAlphabets(e); }}
                                            disabled={disableField}
                                        />
                                        <ErrorMessage
                                            name="district"
                                            component="div"
                                            className="text-error" />
                                    </Form.Group>
                                </div>
                            </Col>
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <div className="input-div position-relative">
                                    <Form.Group controlId="mandal" >
                                        <Form.Label className="input-lable mb-lg-3 mb-0">Mandal<font color="red">*</font></Form.Label>
                                        <Field type="text" name="mandal"
                                            maxLength='30'
                                            className="input-field form-control"
                                            onInput={(e) => { handleInputToUppercase(e) }}
                                            onKeyPress={(e) => { handleKeyPressAlphabets(e) }}
                                            disabled={disableField}
                                        />
                                        <ErrorMessage
                                            name="mandal"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>

                                </div>
                            </Col>
                        </React.Fragment>
                        : <React.Fragment>

                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <div className="input-div position-relative">
                                    <Form.Group controlId="district" >
                                        <Form.Label className="input-lable mb-lg-3 mb-0">District<font color="red">*</font></Form.Label>
                                        <Field as="select" className="input-field form-control" name='district'
                                            disabled={disableField}
                                            onChange={(e) => {
                                                Formik.setFieldValue('mandal', '')
                                                setDistCode(e.target.value)

                                            }}>
                                            <option>-- Select District --</option>
                                            {showDistrictMandal?.districts?.map((ds, i) => {
                                                return (<option key={i} value={ds.dist_code}>{ds.dist_name}</option>);
                                            })}

                                        </Field>
                                        <ErrorMessage
                                            name="district"
                                            component="div"
                                            className="text-error"

                                        />
                                    </Form.Group>
                                    <IoIosArrowDown className="dropdown-icon" />
                                </div>
                            </Col>
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <div className="input-div position-relative">
                                    <Form.Group controlId="mandal" >
                                        <Form.Label className="input-lable mb-lg-3 mb-0">Mandal<font color="red">*</font></Form.Label>
                                        <Field as="select" className="input-field form-control" name='mandal' disabled={disableField}
                                            onChange={(e) => {
                                                Formik.setFieldValue('village', '')
                                                setMandalCode(e.target.value)

                                            }}>
                                            <option>-- Select Mandal --</option>
                                            {showMandal?.map((ds, i) => {
                                                return (<option key={i} value={ds.mandal_code}>{ds.mandal_name}</option>);
                                            })}

                                        </Field>
                                        <ErrorMessage
                                            name="mandal"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>
                                    <IoIosArrowDown className="dropdown-icon" />
                                </div>
                            </Col>
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <div className="input-div position-relative">
                                    <Form.Group controlId="village" >
                                        <Form.Label className="input-lable mb-lg-3 mb-0">Village<font color="red">*</font></Form.Label>
                                        <Field as="select" className="input-field form-control" name='village' disabled={disableField}>

                                            <option>-- Select Village --</option>
                                            {showVillage?.map((ds, i) => {
                                                return (<option key={i} value={ds.village_code}>{ds.village_name}</option>);
                                            })}
                                        </Field>
                                        <ErrorMessage
                                            name="village"
                                            component="div"
                                            className="text-error"
                                        />
                                    </Form.Group>
                                    <IoIosArrowDown className="dropdown-icon" />
                                </div>
                            </Col>
                        </React.Fragment>}

                    <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group controlId="pinCode" >
                            <Form.Label className="input-lable mb-2">Pin Code<font color="red">*</font></Form.Label>
                            <Field
                                type="text"
                                name="pinCode"
                                className="input-field form-control"
                                placeholder="xxxxxx"
                                maxLength="6"
                                onKeyPress={(e) => { handleKeyPressNumeric(e); }} disabled={disableField}/>
                            <ErrorMessage
                                name="pinCode"
                                component="div"
                                className="text-error"
                            />
                        </Form.Group>
                    </Col>
                    
                    <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group controlId="doorNo" >
                            <Form.Label className="input-lable mb-2">Door No.<font color="red">*</font></Form.Label>
                            <Field
                                type="text"
                                className="input-field form-control"
                                name="doorNo" maxLength='15'
                                placeholder="Enter Door No." disabled={disableField}/>
                            <ErrorMessage
                                name="doorNo"
                                component="div"
                                className="text-error"
                            />
                        </Form.Group>
                    </Col>
                    <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="text-area-box mb-3 position-relative">
                        <Form.Group controlId="address" className="position-relative mb-lg-4 mb-0">
                            <Form.Label className="input-lable mb-2">LandMark<font color="red">*</font></Form.Label>
                            <Field
                                type="text"
                                name='address'
                                placeholder="Enter Landmark"
                                disabled={disableField}
                                className="input-field form-control "
                            // style={{ padding: "15px 10px 35px 10px" }}
                            />
                            <ErrorMessage
                                name="address"
                                component="div"
                                className="text-error"
                            />
                        </Form.Group>
                    </Col>
                    <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group controlId="email">
                            <Form.Label className="input-lable mb-2">Email<font color="red">*</font></Form.Label>
                            <Field
                                type="text"
                                className="input-field form-control"
                                name="email"
                                maxLength='100'
                                placeholder="Enter Email"
                                disabled={disableField}
                            />
                            <ErrorMessage
                                name="email"
                                component="div"
                                className="text-error"
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </div>

        </React.Fragment>
    )
}
